import { track } from '@nrdy-marketing-engine/tracking';

import { SubmitFormActionData } from '../../@types/action';
import { StepData } from '../../@types/step-data';
import Action, { ActionProps } from '../action';
import newContact from './submit-form-action/new-contact';

function getSubmitFormActionMap(): Record<string, (action: SubmitFormAction) => Promise<{}>> {
  return {
    new_contact: newContact,
  };
}

function renameToLegacyAction(submitFormActionData: SubmitFormActionData) {
  return submitFormActionData.action === 'new_contact'
    ? 'lead_creation'
    : submitFormActionData.action;
}

interface SubmitFormActionProps extends ActionProps {
  step: SubmitFormActionData;
}

/** An Action subclass that handles form submission actions. */
class SubmitFormAction extends Action {
  step: SubmitFormActionData;

  constructor(props: SubmitFormActionProps) {
    super(props);
    this.step = props.step;
  }

  formAction() {
    return getSubmitFormActionMap()[this.action];
  }

  trackSubmit(category) {
    const actionName = renameToLegacyAction(this.step);

    track('lead-form', {
      category,
      label: actionName,
      target: actionName,
      dataAttributes: { ...this.formMetaData, leadFormAction: actionName },
    });
  }

  async trackSuccess() {
    this.trackSubmit('form_wizard_submit');
  }

  trackFailure() {
    this.trackSubmit('form_wizard_submit_failure');
  }

  async submitForm() {
    const formAction = this.formAction();

    if (formAction) {
      try {
        const newFormData = await formAction(this);
        Object.assign(this.formData, newFormData);
        this.trackSuccess();
      } catch (e) {
        this.trackFailure();

        throw e;
      }

      return this.getNextStep();
    }

    // if form action is not in the map above, throw an error
    throw `Unexpected submit form action ${this.action}`;
  }

  async perform(): Promise<StepData> {
    try {
      return await this.submitForm();
    } catch (exception) {
      // all errors thrown are considered 'unexpected' and should be logged
      console.error(exception);
      throw exception;
    }
  }

  get action() {
    return this.step.action;
  }
}

export default SubmitFormAction;
